/*
 * SPDX-FileCopyrightText: 2021 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { allReducers } from './reducers'
import { configureStore } from '@reduxjs/toolkit'
import { isDevMode } from '../utils/test-modes'
import { middlewares } from '@services/utils';
import { setupListeners } from '@reduxjs/toolkit/dist/query'
import type { ApplicationState } from './application-state'

export const store = configureStore({
  reducer: allReducers,
  devTools: isDevMode,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares),
})

setupListeners(store.dispatch);

export const getGlobalState = (): ApplicationState => store.getState()
